export default class MessageEvent {
  constructor(options) {
    this._currentTerminal = options.currentTerminal // 当前终端
    this._targetTerminal = options.targetTerminal // 远程终端
    this._targetOrigin = options.targetOrigin || '*' // 域
    this._handlers = {} // 响应函数

    const receiveMessage = pEvent => {
      const { event, data } = pEvent.data
      const handlers = this._handlers[event] || []
      handlers.length &&
        handlers.forEach(handler => {
          if (Array.isArray(data)) {
            handler(...(data || []))
          } else {
            handler(data || {})
          }
        })
    }

    this._currentTerminal.addEventListener('message', receiveMessage, false)
  }
  setTargetTerminal(terminal) {
    this._targetTerminal = terminal
  }

  on(event, handler) {
    const handle = this._handlers[event]
    this._handlers[event] = handle ? this._handlers[event].push(handler) : [handler]
  }

  emit(event, ...args) {
    try {
      //跨域时console会阻止postMessage执行      // console.log(this._targetTerminal, event, args)
      this._targetTerminal.postMessage({ event, data: args }, this._targetOrigin)
    } catch (e) {
      console.log(e)
    }
  }

  off(event, handler) {
    if (!this._handlers[event]) {
      return
    }
    if (!handler) {
      this._handlers[event] = []
      return
    }
    this._handlers[event] = this._handlers[event].filter(fn => handler !== fn)
  }
}
